// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import dayjs from 'dayjs';
import type { IlliquidAssetEvent } from '@shared/data-access/types/engine-types';

export const groupIlliquidEventsByYear = (
  events: readonly IlliquidAssetEvent[],
): ReadonlyArray<{ year: number; events: IlliquidAssetEvent[] }> => {
  const sortedEvents = [...events].sort(
    (left, right) =>
      dayjs(right.event_date).valueOf() - dayjs(left.event_date).valueOf(),
  );

  const grouped = sortedEvents.reduce<Record<number, IlliquidAssetEvent[]>>(
    (accumulator, event) => {
      const year = dayjs(event.event_date).year();

      return {
        ...accumulator,
        [year]: [...(accumulator[year] ?? []), event],
      };
    },
    {},
  );

  return Object.entries(grouped)
    .map(([year, yearEvents]) => ({
      year: Number(year),
      events: yearEvents,
    }))
    .sort((left, right) => right.year - left.year);
};
